import { SignIn } from '@develio/auth/client';

export function SignInRoute() {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#F5F7FA] px-4">
      {/* Subtle background shapes echoing the logo mark */}
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div
          style={{
            position: 'absolute',
            bottom: '-8%',
            left: '-6%',
            width: '44%',
            height: '68%',
            background: '#5BBF3A',
            borderRadius: '64px',
            opacity: 0.06,
            transform: 'rotate(-7deg)',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: '-4%',
            right: '-4%',
            width: '36%',
            height: '58%',
            background: '#1B8A8A',
            borderRadius: '56px',
            opacity: 0.07,
            transform: 'rotate(6deg)',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: '8%',
            left: '22%',
            width: '18%',
            height: '22%',
            background: '#E8501A',
            borderRadius: '40px',
            opacity: 0.05,
            transform: 'rotate(-10deg)',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '12%',
            right: '8%',
            width: '26%',
            height: '38%',
            background: '#2C3E50',
            borderRadius: '52px',
            opacity: 0.04,
            transform: 'rotate(9deg)',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '5%',
            right: '22%',
            width: '20%',
            height: '30%',
            background: '#7B8B98',
            borderRadius: '48px',
            opacity: 0.05,
            transform: 'rotate(-4deg)',
          }}
        />
      </div>
      <div className="relative z-10 w-full max-w-md">
        <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />
      </div>
    </div>
  );
}
